<template>
  <div class="our-mission-block">
    <div class="container">
      <h3>Our Mission</h3>
      <h2>Play Boldly, Earn Freely, Live Fully</h2>
      <p>TRUE WORLD is where luck meets progression, where risk meets adventure, and&nbsp;where <span>games are more than entertainment</span> — they are experiences.</p>
      <div class="cards">
        <div class="card">
          <strong>Play & Progress</strong>
          <div class="image">
            <img src="./images/our-mission-bg-image-01.png">
          </div>
          <div class="text">
            Every win isn’t just reward, <span>it’s&nbsp;a&nbsp;step toward something greater</span>.
          </div>
        </div>
        <div class="card">
          <strong>Compete & Conquer</strong>
          <div class="image">
            <img src="./images/our-mission-bg-image-02.png">
          </div>
          <div class="text">
            Join tournaments, battle for glory, <span>claim your place among legends</span>.
          </div>
        </div>
        <div class="card">
          <strong>Collect & Own</strong>
          <div class="image">
            <img src="./images/our-mission-bg-image-03.png">
          </div>
          <div class="text">
            Earn exclusive assets, trade, and shape your legacy in TRUE WORLD.
          </div>
        </div>
      </div>

      <div class="buttons">
        <a href="#/signup" v-if="this.$store.state.isGuest">Sign Up</a>
        <a href="/market" v-else>Explore</a>

        <img src="./images/play-responsible.svg">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'our-mission-block',
  data() {
    return {
      games: [],
    }
  },
  methods: {
    getPopularGames: async function() {
      await this.$request.get('/true-world/upcoming-games', null, response => {
        this.games = response
        this.games = this.games.slice(0,4);
      }, error => {
        console.log(error)
      })
    },
    imageUrlAlt: (event) => {
      event.target.src = require("./images/no-image.png");
    }
  },
  async mounted() {
    await this.getPopularGames();
  }
}
</script>

<style lang="less" scoped>
  .our-mission-block {
    padding-top: 140px;
    padding-bottom: 167px;
    background-image: url("./images/Top-Shape-Image-2.png");
    background-position: top center;
    background-size: 2560px;
    background-repeat: no-repeat;

    > .container {
      > h3 {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 500;
        font-size: 30px;
        line-height: 45px;
        text-align: center;
        margin-bottom: 2px;
        background: linear-gradient(90.62deg, #DF60FF 0%, #9C94FF 49.03%, #44E9C3 62.94%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
      }
      > h2 {
        color: #FFF;
        font-family: Poppins;
        font-weight: 700;
        font-size: 50px;
        line-height: 64px;
        text-align: center;
        margin-bottom: 16px;
      }
      > p {
        color: #FFFFFF99;
        font-family: Poppins;
        font-weight: 500;
        font-size: 24px;
        line-height: 38px;
        text-align: center;
        margin-bottom: 50px;
        > span {
          color: #FFF;
        }
      }
      > .cards {
        display: flex;
        gap: 20px;
        margin-bottom: 40px;
        > .card {
          width: 380px;
          height: 322px;
          background: #C9D8FF1A;
          border-radius: 40px;
          padding: 0 40px 46px 40px;
          position: relative;
          display: flex;
          align-items: flex-start;
          justify-content: flex-end;
          flex-direction: column;
          > strong {
            display: block;
            color: #FFF;
            font-family: Poppins;
            font-weight: 700;
            font-size: 20px;
            line-height: 28px;
            margin-bottom: 6px;
            z-index: 1;
          }
          > .text {
            display: block;
            color: #FFFFFF99;
            font-family: Poppins;
            font-weight: 500;
            font-size: 18px;
            line-height: 28px;
            z-index: 1;
            > span {
              color: #FFF;
            }
          }
          > .image {
            position: absolute;
            top: 0;
            left: 0;
            > img {
              display: block;
              width: 100%;
            }
          }
        }
      }
      > .buttons {
        position: relative;
        display: flex;
        gap: 10px;
        justify-content: center;
        align-items: center;
        > a {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 310px;
          height: 60px;
          border-radius: 14px;
          transition: all .2s;
          color: #fff;
          font-size: 16px;
          line-height: 24px;
          background: linear-gradient(90deg, #9D5BFF 0%, #563AE7 100%);
          &:hover {
            background: linear-gradient(90deg, #9D5BFF 20%, #563AE7 80%);
          }
        }
        > img {
          position: absolute;
          right: 0;
          top: 12px;
        }
      }
    }
  }

  @media screen and (max-width: 1439px) {
    .our-mission-block {
      padding-top: 100px;
      padding-bottom: 88px;
      background-size: 1920px;

      > .container {
        > h3 {
          font-size: 24px;
          line-height: 32px;
          margin-bottom: 0;
        }
        > h2 {
          font-size: 46px;
          line-height: 50px;
          margin-bottom: 12px;
        }
        > p {
          font-size: 18px;
          line-height: 28px;
          margin-bottom: 40px;
        }
        > .cards {
          display: flex;
          gap: 12px;
          margin-bottom: 40px;
          > .card {
            width: 274px;
            height: 310px;
            border-radius: 30px;
            padding: 0 30px 34px 30px;
            > strong {
              font-size: 18px;
              line-height: 24px;
              margin-bottom: 6px;
            }
            > .text {
              font-size: 16px;
              line-height: 26px;
            }
          }
        }
        > .buttons {
          display: flex;
          gap: 10px;
          justify-content: center;
          align-items: center;
          > a {
            width: 220px;
            height: 50px;
            border-radius: 12px;
            font-size: 14px;
            line-height: 24px;
          }
          > img {
            position: absolute;
            right: 0;
            top: 6px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1023px) {
    .our-mission-block {
      padding-top: 70px;
      padding-bottom: 98px;
      background-size: 1920px;

      > .container {
        > h3 {
          font-size: 20px;
          line-height: 28px;
          margin-bottom: 0;
        }
        > h2 {
          font-size: 36px;
          line-height: 40px;
          margin-bottom: 10px;
        }
        > p {
          font-size: 16px;
          line-height: 26px;
          margin-bottom: 30px;
        }
        > .cards {
          display: flex;
          gap: 12px;
          margin-bottom: 40px;
          > .card {
            width: 212px;
            height: 270px;
            border-radius: 20px;
            padding: 0 20px 24px 20px;
            > strong {
              font-size: 16px;
              line-height: 20px;
              margin-bottom: 4px;
            }
            > .text {
              font-size: 14px;
              line-height: 22px;
              height: 88px;
            }
          }
        }
        > .buttons {
          display: flex;
          gap: 10px;
          justify-content: center;
          align-items: center;
          > a {
            width: 220px;
            height: 50px;
            border-radius: 12px;
            font-size: 14px;
            line-height: 24px;
          }
          > img {
            position: absolute;
            right: 0;
            top: 12px;
            width: 108px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    .our-mission-block {
      padding-top: 60px;
      padding-bottom: 41px;
      background-size: 1920px;

      > .container {
        > h3 {
          font-size: 14px;
          line-height: 20px;
          margin-bottom: 0;
        }
        > h2 {
          font-size: 22px;
          line-height: 26px;
          margin-bottom: 6px;
        }
        > p {
          font-size: 13px;
          line-height: 22px;
          margin-bottom: 20px;
        }
        > .cards {
          display: flex;
          gap: 10px;
          margin-bottom: 20px;
          overflow-x: scroll;
          > .card {
            min-width: 212px;
            width: 212px;
            height: 230px;
            border-radius: 20px;
            padding: 0 20px 15px 20px;
            > strong {
              font-size: 14px;
              line-height: 18px;
              margin-bottom: 4px;
            }
            > .text {
              font-size: 12px;
              line-height: 20px;
              height: 60px;
            }
          }
        }
        > .buttons {
          display: flex;
          flex-direction: column;
          gap: 22px;
          justify-content: center;
          align-items: center;
          > a {
            width: 100%;
            height: 40px;
            border-radius: 12px;
            font-size: 13px;
            line-height: 24px;
          }
          > img {
            position: relative;
            right: auto;
            top: auto;
            width: 108px;
          }
        }
      }
    }
  }
</style>
